import React, { Component } from "react";
import { Row, Col, Card, Form } from "reactstrap";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import { URL, optionStatuses } from "../../redux/actions/constants";
import { withRouter } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";

class CompanyUserGroupAddUpdate extends Component {
  state = {
    pageTitle: "Firma Personel Grup Ekle",
    pageTitleAdd: "Firma Personel Grup Ekle",
    pageTitleUpdate: "Firma Personel Grup Güncelle",
    pageAddLink: "firma-personel-grup-ekle",
    pageListLink: "firma-personel-grup-listele",
    breadcrumb: [{ text: "Firma Personel Grupları", link: "#" }],
    isLoading: false,
    urlSplit: [],
    name: "",
    status: true,
    guid: "",
    operationClaimId: "",
    operationClaimArr: [],
    operationClaimOption: [],
    operationClaimError: "",
    nameError: "",
    alertSuccessMessage: "",
    alertAddSuccessMessage: "",
    alertErrorMessage: "",
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit,
    });
    await axios
      .get(URL + "/operationClaims/getlist/special", config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.id,
            label: item.description,
          };
        });
        this.setState({
          operationClaimOption: myArr,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    if (urlSplit.length === 3) {
      this.setState({
        guid: urlSplit[urlSplit.length - 1],
        pageTitle: this.state.pageTitleUpdate,
        isLoading: true,
      });
      this.getById(urlSplit[2]);
      await axios
        .get(URL + "/groups/get/" + urlSplit[2], config)
        .then((response) => {
          if (this.state.guid) {
            response.data.userOperationClaimDto.forEach((element) => {
              var operationClaim = {};
              operationClaim.value = element.operationClaimId;
              this.state.operationClaimArr.push(operationClaim);
            });
            this.setState({
              name: response.data.name,
              status: response.data.status,
              isLoading: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  componentDidUpdate() {
    let urlSplit = window.location.pathname.split("/");
    if (
      urlSplit.length === 2 &&
      this.state.pageTitle !== this.state.pageTitleAdd
    ) {
      this.setState({
        pageTitle: this.state.pageTitleAdd,
        urlSplit: urlSplit,
        name: "",
        operationClaimArr: [],
        status: true,
      });
    }
    if (this.state.status === undefined) {
      this.setState({
        status: true,
      });
    }
  }

  getById(guid) {
    this.setState({
      guid: guid,
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      nameError: "",
      alertErrorMessage: "",
    });
    if (name === "name" && value === "") {
      this.setState({
        nameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  handleOperationClaimSelectChange(option) {
    if (option && option.length > 0) {
      this.setState({
        operationClaimArr: option,
        operationClaimError: "",
        alertErrorMessage: "",
      });
    }
    // else {
    //   this.setState({
    //     operationClaimArr: [],
    //     operationClaimError: CgnMessage.textErrorMessage,
    //     alertErrorMessage: CgnMessage.alertErrorMessage,
    //   });
    // }
  }

  handleStatusSelectChange(status) {
    this.setState({ status: status.value });
  }

  handleClear = (event) => {
    this.clearPage();
  };

  clearPage() {
    this.setState({
      name: "",
      operationClaimArr: [],
      status: true,
      nameError: CgnMessage.textErrorMessage,
      alertErrorMessage: CgnMessage.alertErrorMessage,
    });
  }

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      nameError: "",
      operationClaimError: "",
      alertErrorMessage: "",
    });
    if (this.state.name === "") {
      this.setState({
        nameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    // if (this.state.operationClaimArr.length === 0) {
    //   this.setState({
    //     operationClaimError: CgnMessage.textErrorMessage,
    //     alertErrorMessage: CgnMessage.alertErrorMessage,
    //   });
    // }
    // else if (this.state.name && this.state.operationClaimArr) {
    else if (this.state.name) {
      this.setState({
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var operationClaimArr = [];
      await this.state.operationClaimArr.forEach((element) => {
        var operationClaim = {};
        operationClaim.operationClaimId = element.value;
        operationClaimArr.push(operationClaim);
      });
      var myObj = {
        name: this.state.name,
        userOperationClaimDto: operationClaimArr,
        status: this.state.status,
      };
      var URLParam = "/groups/addgroupbygroupadmin";
      if (this.state.guid && this.state.urlSplit.length !== 2 && this.state.urlSplit[1] === "firma-personel-grup-guncelle") {
        URLParam = "/groups/updategroupbygroupadmin";
        myObj = {
          guid: this.state.guid,
          name: this.state.name,
          userOperationClaimDto: operationClaimArr,
          status: this.state.status,
          isDeleted: this.state.isDeleted,
        };
      }
      axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {

            var modalAddedCompanyUserGroup = {
              data: this.state.name,
              isModal: false,
            };
            this.props.history.push({ modalAddedCompanyUserGroup });

            confirmAlert({
              title: CgnMessage.alertSuccessTitle,
              message: this.state.guid ? CgnMessage.updateSuccessMessage : CgnMessage.addSuccessMessage,
              buttons: [
                {
                  label: CgnMessage.closeButton,
                  onClick: () => {
                    if (this.state.guid && this.state.urlSplit[1] === "firma-personel-grup-guncelle") {
                      window.location.href = "/firma-personel-grup-listele";
                    }
                    if (this.state.urlSplit[1] === "firma-personel-grup-ekle") {
                      window.location.reload();
                    }
                  }
                },
              ],
            });
          }, 1500);
        })
        .catch((error) => {
          confirmAlert({
            title: CgnMessage.alertErrorTitle,
            message: error.response.data,
            buttons: [
              {
                label: CgnMessage.closeButton,
                onClick: () => {
                  this.setState({
                    isLoading: false,
                  });
                }
              },
            ],
          });
        });
    }
  };

  render() {
    return (
      <>
        {(this.state.urlSplit[1] === "firma-personel-grup-ekle" ||
          this.state.urlSplit[1] === "firma-personel-grup-guncelle") && (
            <ContentTop
              breadcrumb={this.state.breadcrumb}
              title={this.state.pageTitle}
              addLink={"/" + this.state.pageAddLink}
              listLink={"/" + this.state.pageListLink}
            />
          )}
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />
                <Row>
                  <Col lg="6">
                    <CgnTextbox
                      type="text"
                      name="name"
                      label="Firma Personel Grup [*]"
                      value={this.state.name}
                      placeHolder="Lütfen personel grubu girin..."
                      maxLength="50"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.nameError}
                    />
                  </Col>
                  <Col lg="6">
                    <CgnReactSelect
                      name="operationClaimId"
                      label="Firma Personel Grup Yetkileri"
                      placeholder="Firma personel grup yetkileri seçiniz..."
                      isMulti={true}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleOperationClaimSelectChange(option)
                      }
                      options={this.state.operationClaimOption}
                      selectValue={this.state.operationClaimArr}
                      error={this.state.operationClaimError}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <CgnReactSelect
                      name="status"
                      label="Durumu"
                      isMulti={false}
                      selectValue={this.state.status}
                      options={optionStatuses}
                      onChange={(status) =>
                        this.handleStatusSelectChange(status)
                      }
                    />
                  </Col>
                </Row>
                {(this.state.alertSuccessMessage ||
                  this.state.alertAddSuccessMessage) && (
                    <CgnAlert
                      color="success"
                      title={CgnMessage.alertSuccessTitle}
                      text={
                        this.state.alertSuccessMessage ||
                        this.state.alertAddSuccessMessage
                      }
                    />
                  )}
                {(this.state.alertErrorMessage ||
                  this.state.adminErrorMessage) && (
                    <CgnAlert
                      color="danger"
                      title={CgnMessage.alertErrorTitle}
                      text={
                        this.state.alertErrorMessage ||
                        this.state.adminErrorMessage
                      }
                    />
                  )}
                <CgnButtonGroup items={this.state.buttons} />
              </Card>
            </Form>
            {(this.state.urlSplit[1] === "firma-personel-grup-ekle" ||
              this.state.urlSplit[1] === "firma-personel-grup-guncelle") && (
                <CgnButtonLink
                  color="secondary"
                  to={"/" + this.state.pageListLink}
                  text={CgnMessage.backButton}
                  className="btn-back"
                />
              )}
          </Col>
        </Row>
      </>
    );
  }
}

export default withRouter(CompanyUserGroupAddUpdate);
